import { DateFormatterToken } from '../../types/functions/date-formatter-token';
import { dateFormatters } from './formatters/formatters';
import { convertDateToOffsetUtc } from './utils/convert-date-to-offset-utc';
import { getDateFormatString } from './utils/get-date-format-string';
import { parseDate } from './utils/parse-date';
import { removeFormattingTokens } from './utils/remove-formatting-tokens';
/**
 * Formats a given `DateInput`, based on the provided `DateFormatOptions`.
 * Adheres to the format provided by date-fns (https://date-fns.org/v1.28.0/docs/format).
 *
 * @hidden
 * @param value The `DateInput` value to be formatted.
 * @param options The date format options to be used.
 * @returns The formatted date string.
 */
export const formatDate = (value, options) => {
    const { languageTag, ianaTimeZoneName, ordinalStringFormatter } = options;
    const date = parseDate(value);
    const formatString = getDateFormatString(options);
    const matches = formatString.match(formattingTokensRegex) || [];
    const params = {
        date,
        languageTag,
        ianaTimeZoneName,
        offsetUtcDate: convertDateToOffsetUtc(date, ianaTimeZoneName),
        ordinalStringFormatter: ordinalStringFormatter
    };
    const formattedParts = matches.map((match) => {
        const formatter = dateFormatters[match];
        if (!formatter) {
            return removeFormattingTokens(match);
        }
        return formatter(params);
    });
    return formattedParts.join('');
};
/**
 * The supported date format tokens, joined using a '|' character and sorted in reverse alphabetical order.
 * (e.g. "cccc|ccc|bb|b|aaa|aa|a").
 */
const formatterTokens = Object.values(DateFormatterToken).sort().reverse().join('|');
/**
 * A regular expression that:
 *  - first, matches any strings starting with '[' and ending with ']'
 *  - then, matches any of the formatter tokens
 *  - finally, matches anything else
 */
export const formattingTokensRegex = new RegExp(`\\[[^\\[]*\\]|${formatterTokens}|.`, 'g');
//# sourceMappingURL=format-date.js.map